import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="visibility"
export default class extends Controller {
  // static targets = ["toggleable"];

  // connect() {
  //   // Optional: Hide elements initially if they aren't hidden by default CSS
  //   // this.hideAllTargets();
  // }

  // show(event) {
  //   this.hideAllTargets(); // Hide all other elements first
  //   const targetId = event.currentTarget.dataset.showTarget;
  //   const targetElement = document.getElementById(targetId);
  //   if (targetElement) {
  //     targetElement.classList.remove("hidden"); // Show the specific element
  //   }
  // }

  // hideAllTargets() {
  //   // Iterate over all elements designated as 'toggleable' targets and hide them
  //   this.toggleableTargets.forEach((element) => {
  //     element.classList.add("hidden");
  //   });
  // }

  static targets = ["button", "content"];
  // Declare a value to store the active class (Tailwind classes)
  static values = {
    activeClass: {
      type: String,
      default: "bg-green-50 border-emerald-600",
    },
    inactiveClass: {
      type: String,
      default: "border-gray-200 hover:border-gray-300",
    },
  };

  connect() {
    // Ensure the first button and content are active/visible by default on connect
    this.activateTab(this.buttonTargets[0]);
    this.showContent(0);
  }

  changeTab(event) {
    // Prevent default link behavior if using links
    event.preventDefault();

    // Deactivate all buttons and hide all content
    this.buttonTargets.forEach((button) => this.deactivateTab(button));
    this.contentTargets.forEach((content) => content.classList.add("hidden"));

    // Activate the clicked button
    const clickedButton = event.currentTarget;
    this.activateTab(clickedButton);

    // Show the associated content based on its index
    const index = this.buttonTargets.indexOf(clickedButton);
    this.showContent(index);
  }

  activateTab(button) {
    button.classList.remove(...this.inactiveClassValue.split(" "));
    button.classList.add(...this.activeClassValue.split(" "));
  }

  deactivateTab(button) {
    button.classList.remove(...this.activeClassValue.split(" "));
    button.classList.add(...this.inactiveClassValue.split(" "));
  }

  showContent(index) {
    if (this.hasContentTarget && this.contentTargets[index]) {
      this.contentTargets[index].classList.remove("hidden");
    }
  }
}
